export default class GetWalletState {}
